<template>
  <i-form label-position="left" :label-width="120" class="default-form client-contract">
    <div class="contract-form-group">
      
      <div>
        <Row>
          <i-col span="24" class="default-form-member-col">
            <FormItem label="文件名" class="default-form-item" required>
              <i-input v-model="address.fileName" :readonly="edit === false"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </div>
      <div>
        <Row>
          <i-col span="24" class="default-form-member-col">
            <FormItem label="企业微信云盘地址" class="default-form-item" required>
              <div v-if="edit === false" class="default-form-member-selection">
                <a :href="address.url" target="_blank">{{address.url}}</a>
              </div>
              <i-input v-else v-model="address.url"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </div>
        
    </div>
  </i-form>
</template>
<script>
export default {
  props: {
    address: {
      type: Object
    },
    edit: {
      type: Boolean
    }
  }
};
</script>
<style scoped lang="less">
  
.client-contract{
margin-top: 20px;
}
.contract-form-group {
  border-bottom: none !important;
  /deep/.ivu-form-item-label {
    text-align: left;
    padding-left: 20px;
    font-weight: bolder;
  }
  /deep/.ivu-input{
    height: 53px;
    border: none;
  padding-left:20px ;
}
> div:last-child{
   border-bottom: 1px solid #ced4da
 }
}
</style>

